<template>
  <div>
    <section class="orderSect">
      <!--S 检索-->      
      <el-form inline :model="formInline">
        <el-form-item :label="expecttitle">
          <el-date-picker 
          v-model="formInline.expectedDelvDate" 
          type="daterange"          
          range-separater="至" 
          start-placeholder="开始日期" 
          end-placeholder="结束日期"
          :picker-options="formInline.orderDateOptions"
          :unlink-panels = "true" clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-if="sppsfw == 1" v-model="formInline.timeSlot" placeholder="请选择" class="formTimeSlot" clearable>
            <el-option label="中午" value="09:00:00"></el-option>
            <el-option label="晚上" value="15:00:00"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号" class="codeSerIpt">
              <el-input  v-model="formInline.orderno" placeholder="请输入订单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号">
              <el-input  v-model="formInline.phone" placeholder="请输入手机号" clearable></el-input>
          </el-form-item>
          <el-form-item label="收货人">
              <el-input  v-model="formInline.Name" placeholder="请输入收货人姓名" clearable></el-input>
          </el-form-item> 
          <el-form-item>
              <el-button type="primary" @click="getPenordshippedList">查询</el-button>
          </el-form-item>
          <em class="simpleSearch" @click="highShow = !highShow">{{highShow?'精简筛选':'高级筛选'}}</em>
          <div class="none" :class="{'block':highShow}">
             <!-- 配送方下拉组件 S -->
            <DeliveryAreaSelect  @deliveryObtain="deliveryReceive"></DeliveryAreaSelect>
            <!-- 配送方下拉组件 E -->
            <!--S 配送区域-->
            <el-form-item label="自配区">
              <SelProCityArea  :regioncode="formInline.delivery" @pcdlistclick="pcdlistclick"></SelProCityArea>
            </el-form-item>
            <!--E 配送区域-->
            <el-form-item label="省/市">
                <el-input v-model="formInline.city" placeholder="请输入省/市" clearable></el-input>
            </el-form-item>
            <el-form-item label="订单内容">
                <el-input v-model="formInline.orderContent" placeholder="请输入订单内容" clearable></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-model="formInline.orderMemo" placeholder="请输入内容" clearable></el-input>
            </el-form-item>
            <el-form-item label="预售品牌">
              <!-- 预售品牌下拉组件 S -->
              <PresaleBrandSelect @brandObtain="brandReceive"></PresaleBrandSelect>
              <!-- 预售品牌下拉组件 E -->
            </el-form-item>
            <!-- 订单归属下拉组件 S -->
            <OrderAscription @belongObtain="belongReceive" title="订单归属" cootype="1"></OrderAscription>
            <!-- 订单归属下拉组件 E -->
          </div>   
      </el-form>
    <!--E 检索-->

    <!--S 待发货订单列表-->
    <div class="allOrderTab individualiz">
      <el-form :model="formInline" inline size="medium">
        <el-form-item class="borderline">
          <em class="greyColor">订单来源</em>
          <el-checkbox-group v-model="formInline.source" @change="changesource">
            <el-checkbox v-for="(item,index) of sourceLists" :label="item.value" :key="index">{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item class="borderline">
          <el-checkbox v-model="orderContProp">按订单内容排序</el-checkbox>
        </el-form-item> 
        <el-form-item class="borderline" v-if="ElementControls('system_version')!=1">
          <em class="greyColor">商品类型</em>
          <el-checkbox-group v-model="formgoodstype" @change="changeGoodsType">
            <el-checkbox :label="0">实物商品</el-checkbox>
            <el-checkbox :label="1">实体券卡</el-checkbox>
          </el-checkbox-group>
        </el-form-item>                          
        <el-form-item>
          <el-button type="primary" plain @click="inventoryShow = true">盘点商品清单</el-button>
          <el-button type="primary" plain @click="getPrinted(1)">检索打印</el-button>
          <el-button type="primary" plain @click="getPrinted(0)">勾选打印</el-button>
          <!-- <el-button type="primary" v-if="ElementControls('importExpinfo') == 1" plain @click="getPrinted(2)">Excel导入</el-button> -->
        </el-form-item>
      </el-form>
      <el-table v-loading="loading" :data="allOrderData" ref="orderTable" class="orderTable comTable" border :maxHeight="tableHeight" @selection-change="handleSelectionChange">
            <el-table-column type="selection" fixed width="80"></el-table-column>         
            <el-table-column type="index" label="序号" fixed width="80"></el-table-column>
            <el-table-column label="卖家备注" fixed width="200">
              <template slot-scope="scope">
               <p class="textFl" :title="scope.row.sellermemo"> {{scope.row.sellermemo | empty}}</p>
              </template>
            </el-table-column>
            <el-table-column label="买家备注" width="200">
              <template slot-scope="scope">
                <p class="textFl" :title="scope.row.buyermemo">{{scope.row.buyermemo | empty}}</p>
              </template>
            </el-table-column>
            <el-table-column label="订单号" prop="orderno" sortable min-width="260">
              <template slot-scope="scope">
                <p>
                  <el-tag v-if="scope.row.ordertype==2" type="primary" title="补发订单">补发</el-tag>
                  {{scope.row.orderno}}
                </p>
                <small>下单时间：{{ dateTime(scope.row.submitdate, 1) }}</small>
              </template>
            </el-table-column>
            <el-table-column label="收货信息" prop="fulladdr" sortable width="400">
              <template slot-scope="scope">
                <div class="shouMsg">
                  <strong :class="[{'blueColor':scope.row.delimode==1},{'orangeColor':scope.row.delimode=='0'}]" v-if="scope.row.delimode==1">送货</strong>
                  <strong :class="[{'blueColor':scope.row.delimode==1},{'orangeColor':scope.row.delimode=='0'}]" v-if="scope.row.delimode==0">自提</strong>
                  <em v-if="scope.row.receivername">{{scope.row.receivername}}</em>
                  <em v-if="scope.row.receivertel">{{scope.row.receivertel}}</em>
                </div>              
                <p v-if="scope.row.fulladdr" class="greyColor textFl" :title="scope.row.fulladdr">{{scope.row.fulladdr}}</p>
              </template>
            </el-table-column>
            <el-table-column label="订单内容" prop="ordercontent" sortable width="400">
              <template slot-scope="scope">
                <!-- <div class="greyColor textFl" @click="ElementControls('showKindinfo') == 1 ? showKindinfo(scope.row.ordercontent, scope.row.orderno) : ''" :title="scope.row.ordercontent">{{scope.row.ordercontent}}</div> -->
                <div class="greyColor textFl" :title="scope.row.ordercontent">{{scope.row.ordercontent}}</div>
                <p class="orderContentI">
                  <em class="priceFont"><em>￥</em>{{scope.row.allamount}}</em>
                  <!-- 订单类型 -->
                <i
                  :class="{'iconth':scope.row.ordertype===0,'iconsc': scope.row.ordertype===1,'iconbf':scope.row.ordertype===2,'iconfresh':scope.row.ordertype===3,'iconmd':scope.row.ordertype===5,'el-icon-present':scope.row.ordertype===6}"
                  :title="scope.row.ordertype | orderTypeFilter"
                ></i>

                <!-- 商品类型 -->
                <i
                  :class="{'iconsw':scope.row.goodstype===0,'iconcard': scope.row.goodstype===1,'icone-card':scope.row.goodstype===2}"
                  :title="scope.row.goodstype | goodsTypeFilter"
                ></i>

                <!-- 终端类型 -->
                <i
                  :class="{'iconpc':scope.row.terminaltype===0,'iconiPhone': scope.row.terminaltype===1,'iconwx':scope.row.terminaltype===2}"
                  :title="scope.row.terminaltype | terminalTypeFilter"
                ></i>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="订单来源" prop="prosource" sortable width="200">
              <template slot-scope="scope">
                <p>{{scope.row.prosource | prosourceFilter}}</p>
                <small v-if="scope.row.orderuname" :title="scope.row.orderuname">{{scope.row.orderuname}}</small>
              </template>
            </el-table-column>
            <el-table-column label="发货方" prop="operpower" sortable width="200">
              <template slot-scope="scope">
                <p>
                  <span>{{scope.row.operpower | operpOwerFilter}}</span>
                  [<em :class="[{'blueColor':scope.row.desstate==1},{'greyColor':scope.row.desstate==3},{'redColor':scope.row.desstate==2},{'orangeColor':scope.row.desstate==0 || scope.row.desstate==4}]">
                    <span>{{scope.row.desstate | desStateFilter}}</span>
                  </em>]
                </p>
                <small>{{expecttitle}}：{{dateTime(scope.row.recvdate, 2)}}</small>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="100">
              <template slot-scope="scope">
                <el-dropdown :title="scope.row.bank" trigger="click" @command="handleCommand" placement="bottom-start">
                  <span class="el-dropdown-link">
                    全部操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{'type':'orderDetail', 'orderno':scope.row.orderno}">详情</el-dropdown-item>
                    <el-dropdown-item
                    :command="{'type':'editPrintMemo', 'orderno':scope.row.orderno, 
                    'oldMemo':scope.row.sellermemo, 'bcooorder':scope.row.bcooorder, 'cooqydm':scope.row.cooqydm}">编辑打印备注</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="noData"><span>暂无数据</span></div>
            </template>
      </el-table>
    </div>
    <!--E 待发货订单列表--> 
    <Page operateType="DeliveryFolder" :pageTotal="pagebean.totalnum" :currentPage="pagebean.currentpage" @nowPageParam="setPageparam"></Page>
    </section>

    <!--S 勾选打印组件-->
    <PrintInfo :printInfoBox="printInfoShow" :operatePrint="batchOperate" @closePrintBox="closePrintInfo"></PrintInfo>
    <!--E 勾选打印组件-->

    <!--S 订单详情组件-->
    <OrderDetail :orderDetailBox="orderDetailShow" :orderno="orderno" @closeODBox="orderDetailShow = false"></OrderDetail>
    <!--E 订单详情组件组件-->
    
    <!--S 订单修改备注组件-->
    <OrderMemo :orderMemoBox="orderMemo" :operateMemo="cancelEdit" :oldMemo="oldMemo" @closePrintVal="clsBtnVal" @closeOMemoBox="closeOrderMemo"></OrderMemo>
    <!--E 订单修改备注组件-->

    <!-- S 盘点商品清单弹窗 -->
    <el-dialog v-loading="dialog_loading" class="comDlog inventoryDlog" title="统计待发货订单商品" :visible.sync="inventoryShow" append-to-body :close-on-click-modal="false">
        <!-- <el-form :model="inventoryForm" :inline="true" class="searchForm">
            <el-form-item>
                <el-button type="primary" plain @click="statisticsGoodsExport">导出</el-button>
            </el-form-item>
        </el-form> -->
        <p class="flexBet pb10">
          <span></span>
          <el-button type="danger" size="medium" plain @click="statisticsGoodsExport">导出</el-button>
        </p>
        <el-table class="comTable giftTable" border :data="inventoryData" :height="550">
            <el-table-column label="序号" type="index">
            </el-table-column>
            <el-table-column label="商品规格" min-width="350" sortable prop="kindinfo">
                <template slot-scope="scope">
                    <section class="flexAro pdr70">
                      <span class="goodsImg"><img :src="scope.row.kindpic ? scope.row.kindpic : scope.row.maingoodspic ? scope.row.maingoodspic : 'https://presale.jhtsoft.com/picms/c47499b67d489.png'"/></span>
                      <div class="goodsCont">
                        <h3 class="textFl" :title="scope.row.goodsname">{{scope.row.goodsname}}</h3>
                        <p class="textFl" :title="scope.row.kindinfo">{{scope.row.kindinfo}}</p>
                        <span class="priceFont"><i>￥</i>{{scope.row.goodsmallprice}}</span>
                      </div>
                    </section>
                </template>
            </el-table-column>
            <el-table-column label="上/下架" min-width="150" sortable prop="bsale">
                <template slot-scope="scope">
                    <el-switch :value="scope.row.bsale == 1 ? true : false" disabled :width="55" class="isSwitch" :active-text="scope.row.bsale == 1?'上架':'下架'"></el-switch>
                    <small class="textHiden grey">录入时间：{{dateTime(scope.row.credate, 1)}}</small>
                </template>
            </el-table-column>
            <el-table-column label="商品数量" min-width="150" sortable prop="num">
                <template slot-scope="scope">
                    <span>{{scope.row.num}}</span>
                </template>
            </el-table-column>
            <template slot="empty">
              <div class="noData"><span>暂无数据</span></div>
            </template>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="inventoryShow = false">关闭</el-button>
        </span>
    </el-dialog>
    <!-- E 盘点商品清单弹窗 -->

    <!-- S 规格内容弹窗 -->
    <el-dialog v-loading="dialog_loading" class="comDlog inventoryDlog" title="订单规格内容" :visible.sync="kindinfoShow" append-to-body :close-on-click-modal="false">
        <el-table class="comTable giftTable" border :data="kindinfos" :height="550">
            <el-table-column label="序号" type="index">
            </el-table-column>
            <el-table-column label="商品名称" min-width="150" sortable >
                <template slot-scope="scope">
                    <span>{{scope.row.goodsname}}</span>
                </template>
            </el-table-column>
            <el-table-column label="规格名称" min-width="150" sortable>
                <template slot-scope="scope">
                    <span>{{scope.row.kindinfo}}</span>
                </template>
            </el-table-column>
            <el-table-column label="数量" min-width="150" sortable>
                <template slot-scope="scope">
                    <span>{{scope.row.num}}</span>
                </template>
            </el-table-column>
            <el-table-column label="规格内容" min-width="150" sortable>
                <template slot-scope="scope">
                    <span>{{scope.row.kindcontent}}</span>
                </template>
            </el-table-column>
            <template slot="empty">
              <div><span>{{oldcontent}}</span></div>
            </template>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="kindinfoShow = false">关闭</el-button>
        </span>
    </el-dialog>
    <!-- E 盘点商品清单弹窗 -->
    
  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import api from '../../apis/api';
import {dateTime} from '../../util/dateTime';
import '../../util/stateORtypeFilter.js';
export default {
  name: "ShippedOrderList_SellerMemo",
  data() {
    return {
      kindinfoShow: false,
      oldcontent: '',//不存在商品规格的订单内容
      kindinfos: [],//订单规格内容
      cootype: "1",
      highShow: false, //是否展示高级筛选 //配送方列表
      sourceLists: [
        { label: "总部", value: 0 },
        { label: "门店", value: 1 },
        { label: "消费者", value: 2 },
        { label: "仓分享合作", value: 4 },
        { label: "外部对接", value: 3 }
      ], //订单归属列表
      orderContProp: false, //按订单内容排序
      //检索
      formInline: {
        expectedDelvDate: "", //期望发货日期
        timeSlot: "", //中午、晚上时间段选择
        orderno: "", //订单号
        phone: "", //手机号
        Name: "", //收货人/提货人
        city: "", //省/市
        orderContent: "", //订单内容
        orderMemo: "", //备注
        brand: "", //预售品牌
        delivery: "", //配送方
        provincecode:'',
        citycode:'',
        districtcode:'',
        orderBelong: "", //订单归属
        source: [], //订单来源
        orderDateOptions: {
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                let end = new Date();
                let start = new Date();
                start.setTime(start.getTime());
                picker.$emit("pick", [start, end]);
              }
            },{
              text: "最近一周",
              onClick(picker) {
                let end = new Date();
                let start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近一个月",
              onClick(picker) {
                let end = new Date();
                let start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近三个月",
              onClick(picker) {
                let end = new Date();
                let start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              }
            }
          ]
        }
      },
      batchOperate:0,//打印操作 1:筛选打印；0:勾选打印；2：excel导入
      allOrderData: [
      ], //全部订单数据
      multipleSelection: [], //已选中的行
      tableHeight: window.innerHeight * 0.8, //表格动态高度
      orderDetailShow:false, //订单详情
      cancelEdit:'editPrintMemo', //默认备注操作
      orderMemo:false, //编辑打印备注弹窗
      btnVal:'', //编辑打印备注按钮关编辑打印闭还是确定
      printInfoShow:false, //勾选打印弹窗
      printType:'', //打印类别
      pagebean: {
        pagesize: 30,
        currentpage: 1
      },//分页
      loading: true,//加载
      contentsort: 0,//是否需要订单内容排序 0：否；1：是；
      opeorderno: '',//操作的订单编号
      oldMemo: '',//修改前的打印备注
      bcooorder: 0,//是否仓分享合作订单
      cooqydm: '',//合作方企业代码，
      ordernoArr: [],//勾选的订单编号数组
      orderno: '',//订单号
      subNow: 0,//立即下单
      expecttitle: '',//期望发货日期标题
      inventoryShow:false, //盘点商品清单弹窗
      //商品清单数据
      inventoryData:[],
      // 规格管理筛选
      inventoryForm:{
        keyWord:'',//关键词
      },
      dialog_loading: false,
      sppsfw: 0,//是否开通同城配送
      formgoodstype:[],//商品类型检索
    };
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
    PrintInfo: resolve => require(["@/components/DeliveryFolder/PrintInfo.vue"], resolve), //勾选打印组件
    OrderDetail: resolve => require(["@/components/common/OrderDetail.vue"], resolve), //查看订单详情组件
    OrderMemo: resolve => require(["@/components/OrderFolder/OrderMemo.vue"], resolve), //编辑打印备注组件
    DeliveryAreaSelect: resolve => require(["@/components/common/DeliveryAreaSelect.vue"], resolve), // 配送方下拉组件
    PresaleBrandSelect: resolve => require(["@/components/common/PresaleBrandSelect.vue"], resolve), // 预售品牌下拉组件
    OrderAscription: resolve => require(["@/components/common/OrderAscription.vue"], resolve), // 订单归属下拉组件
    SelProCityArea:resolve => require(["@/components/common/SelProCityArea.vue"], resolve),
  },
  watch: {
    //按订单内容排序
    orderContProp(){
      if(this.orderContProp){
        this.contentsort = 1;
        this.getPenordshippedList();
      }else{
        this.contentsort = 0;
        this.getPenordshippedList();
      }
    },
    'inventoryShow'(val) {
      if(val) {
        this.statisticsGoodsOfOrder()
      }
    },
  },
  methods: {
    //商品类型
    changeGoodsType(val){
      if(val.length>1){
        val.splice(0,1)
      }
      this.changesource();
    },
    pcdlistclick(value){
      this.formInline.provincecode=value[0].provincecode
      this.formInline.citycode=value[1].citycode
      this.formInline.districtcode=value[2].districtcode
    },
    // 配送方下拉选择值
    deliveryReceive(value) {
      this.formInline.delivery = value;
    },
    // 预售品牌下拉选择值
    brandReceive(value) {
      this.formInline.brand = value;
    },
    // 订单归属下拉选择值
    belongReceive(value) {
      this.formInline.orderBelong = value;
    },
    //表格多选选中行复制
    handleSelectionChange(val) { 
      this.multipleSelection = val;
    },
    //打印操作
    getPrinted(val) {
      this.batchOperate = val; //打印操作类型
      if(val == 0){
        if(this.multipleSelection.length > 0){
          this.printInfoShow = true;
        }else{
          MessageBox.alert("请选择要打印的订单！", "系统提示", {
            confirmButtonText: "确定",
            type:'warning'
          }).then(() => {}).catch(() => {})
        }
      }else{
        this.printInfoShow = true;
      }
    },
    //关闭勾选打印弹窗
    closePrintInfo(type, value, memo, fileUrl, subNow){
      if(type == 1) {
        this.printType = value ;
        this.genbatchmemo = memo
        //遍历选中的订单号
        this.multipleSelection.forEach(item => {
          this.ordernoArr.push(item.orderno)
        })
        this.subNow = subNow
        if(this.batchOperate == 0 || this.batchOperate == 1) {
          //调用生成快递的接口
          this.orderPrint()
        } else if (this.batchOperate == 2) {
          //excel导入
          this.importOrder(fileUrl)
        }
      } else {
        this.printInfoShow = false; //弹窗
      }
    },

    //统计待发货订单的商品列表
    statisticsGoodsOfOrder() {
      this.dialog_loading = true
      let params = this.getParam()
      api.STATISTICSGOODSOFORDER(params).then(res => {
        if (res.data.status == '200') {
          this.inventoryData = res.data.data
        } else {
          this.$message.error(res.data.message)
          this.inventoryData = []
        }
        this.dialog_loading = false
      })
    },

    //导出统计待发货订单的商品列表
    statisticsGoodsExport() {
      this.dialog_loading = true
      let params = this.getParam()
      api.STATISTICSGOODSEXPORT(params).then(res => {
        if (res.data.status == '200') {
          window.location.href = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
        this.dialog_loading = false
      })
    },

    getParam() {
      let params = {
        contentsort: this.contentsort,
        stardate: this.formInline.expectedDelvDate && this.formInline.expectedDelvDate[0] ? this.dateTime(this.formInline.expectedDelvDate[0]) : '',
        enddate: this.formInline.expectedDelvDate && this.formInline.expectedDelvDate[1] ? this.dateTime(this.formInline.expectedDelvDate[1]) : '',
        dateAmPm: this.formInline.timeSlot, //中午、晚上时间段选择
        orderno: this.formInline.orderno, //订单号
        mobileNumber: this.formInline.phone, //手机号
        name: this.formInline.Name, //收货人/提货人
        provinceorcity: this.formInline.city, //省/市
        ordercontent: this.formInline.orderContent, //订单内容
        memo: this.formInline.orderMemo, //备注
        brandcode: this.formInline.brand, //预售品牌
        expresscode: this.formInline.delivery, //配送方
        provincecode: this.formInline.provincecode,
        citycode: this.formInline.citycode,
        districtcode: this.formInline.districtcode,
        proxyqydm: this.formInline.orderBelong, //订单归属
        submittype: this.formInline.source, //订单来源
        goodstype:this.formgoodstype.length>0?Number(this.formgoodstype[0]):'',//商品类型
      }
      return params
    },

    //订单导入
    importOrder(fileUrl) {
      let params = {
        printType: this.batchOperate,
        genbatchmemo: this.genbatchmemo,
        selprintType: this.printType,
        perfect: fileUrl
      }
      api.ORDERPRINT(params).then(res => {
        if(res.data.status == '200') {
          Message({
            type: 'success',
            message: '快递导入成功!'
          });
          this.$router.push({
            name:'导入快递'
          });
          this.printInfoShow = false; //弹窗
        } else {
          Message({
            type: 'error',
            message: res.data.message
          });
        }
      })
    },
    
    //操作指令
    handleCommand(command) {
      this.opeorderno = command.orderno;
      if(command.type == 'orderDetail'){ //订单详情
        this.orderno = this.opeorderno
        this.orderDetailShow = true;
      }else if(command.type == 'editPrintMemo'){ //编辑打印备注
        this.oldMemo = command.oldMemo;
        this.bcooorder = command.bcooorder;
        if(this.bcooorder) {
          this.cooqydm = command.cooqydm
        } else {
          this.cooqydm = ''
        }
        this.cancelEdit = 'editPrintMemo';
        this.orderMemo = true;
      }
      
    },
    //编辑打印备注确定还是取消
    clsBtnVal(val){
      this.btnVal = val;
    },
    //确定编辑打印备注
    closeOrderMemo(val){
      this.orderMemo = false; //弹窗
      if(val && this.cancelEdit == 'editPrintMemo'){
        //调用编辑打印备注的接口
        this.editPrintMemo(val);
      }
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.orderTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130;
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
    },
    //设置分页数据
    setPageparam(nowPageSize, nowCurrentPage) {
      if(nowPageSize) {
        this.pagebean.pagesize = nowPageSize;
      }
      if(nowCurrentPage) {
        this.pagebean.currentpage = nowCurrentPage;
      }
      this.getPenordshippedList();
    },
    //查询待发货列表
    getPenordshippedList() {
      this.loading = true;
      let params = {
        contentsort: this.contentsort,
        stardate: this.formInline.expectedDelvDate && this.formInline.expectedDelvDate[0] ? this.dateTime(this.formInline.expectedDelvDate[0]) : '',
        enddate: this.formInline.expectedDelvDate && this.formInline.expectedDelvDate[1] ? this.dateTime(this.formInline.expectedDelvDate[1]) : '',
        dateAmPm: this.formInline.timeSlot, //中午、晚上时间段选择
        orderno: this.formInline.orderno, //订单号
        mobileNumber: this.formInline.phone, //手机号
        name: this.formInline.Name, //收货人/提货人
        provinceorcity: this.formInline.city, //省/市
        ordercontent: this.formInline.orderContent, //订单内容
        memo: this.formInline.orderMemo, //备注
        brandcode: this.formInline.brand, //预售品牌
        expresscode: this.formInline.delivery, //配送方
        provincecode: this.formInline.provincecode,
        citycode: this.formInline.citycode,
        districtcode: this.formInline.districtcode,
        proxyqydm: this.formInline.orderBelong, //订单归属
        submittype: this.formInline.source, //订单来源
        goodstype:this.formgoodstype.length>0?Number(this.formgoodstype[0]):'',
        pageparam: {
          pagesize: this.pagebean.pagesize,
          currentpage: this.pagebean.currentpage
        }
      }
      api.LISTPENORDSHIPPED(params).then(res => {
        if(res.data.status == '200') {
          this.allOrderData = res.data.data;
          this.pagebean = res.data.pagebean;
        } else {
          this.allOrderData = [];
        }
        this.loading = false;
      })
    },
    //检索/勾选打印
    orderPrint() {
      this.loading = true
      let params = {
        printType: this.batchOperate,
        selprintType: this.printType,
        genbatchmemo: this.genbatchmemo,

        //勾选内容
        ordernoArr: this.batchOperate == 0 ? this.ordernoArr : '',

        //检索条件
        stardate: this.formInline.expectedDelvDate && this.formInline.expectedDelvDate[0] ? this.dateTime(this.formInline.expectedDelvDate[0]) : '',
        enddate: this.formInline.expectedDelvDate && this.formInline.expectedDelvDate[1] ? this.dateTime(this.formInline.expectedDelvDate[1]) : '',
        dateAmPm: this.formInline.timeSlot, //中午、晚上时间段选择
        orderno: this.formInline.orderno, //订单号
        mobileNumber: this.formInline.phone, //手机号
        name: this.formInline.Name, //收货人/提货人
        provinceorcity: this.formInline.city, //省/市
        ordercontent: this.formInline.orderContent, //订单内容
        memo: this.formInline.orderMemo, //备注
        brandcode: this.formInline.brand, //预售品牌
        expresscode: this.formInline.delivery, //配送方
        provincecode: this.formInline.provincecode,
        citycode: this.formInline.citycode,
        districtcode: this.formInline.districtcode,
        proxyqydm: this.formInline.orderBelong, //订单归属
        submittype: this.formInline.source, //订单来源
      }
      if(this.batchOperate==1){ //检索打印传参商品类型
        params.goodstype = (this.formgoodstype.length>0 ? Number(this.formgoodstype[0]) : '');
      }
      api.ORDERPRINT(params).then(res => {
        if(res.data.status == '200') {
          Message({
            type: 'success',
            message: '快递生成成功!'
          });
          //非erp跳转热敏打印页面
          if(this.printType != '1004' && this.printType != '1005' && this.printType != '1006' && this.printType != '1007' && this.printType != '1009') {
            //存储批次编号
            let expgenbatchnoArr = []
            expgenbatchnoArr.push(res.data.data.expgenbatchno)
            sessionStorage.setItem('expgenbatchnoArr', JSON.stringify(expgenbatchnoArr))
            this.$router.push({
              name:'针式热敏打印列表',
              params: {
                printType: this.printType,
              }
            });
          } else {
            let type = this.printType == '1004' ? 2 : (this.printType == '1005' ? 1 : (this.printType == '1006' ? 0 : (this.printType == '1009'?5:3)))
            this.$router.push({
              name:'ERP发货记录',
              query: {
                type: type,
                subNow: this.subNow,
              }
            });
          }
          this.printInfoShow = false; //弹窗
        } else {
          Message({
            type: 'error',
            message: res.data.message
          });
        }
        // this.ordernoArr = []
        this.loading = false
      })
    },
    //更改订单归属选择
    changesource() {
      this.pagebean.currentpage = 1;
      this.getPenordshippedList();
    },
    //编辑打印备注
    editPrintMemo(val) {
      this.loading = true
      let params = {
        orderno: this.opeorderno,
        sellermemo: val,
        bcooorder: this.bcooorder,
        cooqydm: this.cooqydm
      }
      api.UPDSELLERMEMO(params).then(res => {
        if(res.data.status == '200') {
          Message({
            type: 'success',
            message: '修改备注成功!'
          });
          this.getPenordshippedList()
        } else {
          Message({
            type: 'error',
            message: res.data.message
          });
        }
        this.loading = false
      })
    },
    //获取订单详情
    getOrderDetail() {
      let params = {
        orderno: this.opeorderno
      }
      api.FINDORDERDETAIL(params).then(res => {
        if(res.data.status == '200') {
          comsole.log(res.data.data)
        } else {
          Message({
            type: 'error',
            message: res.data.message
          });
        }
      })
    },

    //获取商品规格内容
    showKindinfo(oldcontent, orderno) {
      api.LISTGOODSKINDINFOBYORDERNO({orderno: orderno}).then(res => {
        if (res.data.status == '200') {
          this.kindinfos = res.data.data
        } else {
          this.oldcontent = oldcontent
          this.kindinfos = []
        }
        this.kindinfoShow = true
      })
    }
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    //在dom渲染之后
    setTimeout(() => {
      this.getHeight();
      this.getPenordshippedList();
      this.expecttitle = localStorage.getItem("pubordprintinfo") ? JSON.parse(localStorage.getItem("pubordprintinfo")).expecttitle : ''
    }, 200);
    this.sppsfw = Number(this.ElementControls('sppsfw'))
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  }
};
</script>

<style scoped>
@import "Css/Style.css";
.orderContentI i:hover {color:var(--main-color)}
/*盘点清单弹窗 start*/
.inventoryDlog>>>.el-dialog{width:1200px}
.inventoryDlog>>>.el-radio {padding:20px;}
.inventoryDlog>>>.el-dialog__body {max-height:calc(100% -  70px);}
.pb10 {padding-bottom:10px;}
.giftTable{color:#666}
.giftTable>>>.el-switch{margin-bottom:5px}
.goodsImg {display:inline-block; position:relative; width:80px; height:80px; border:solid 1px #dcdfe6;}
.goodsImg img {position:absolute; left:0; top:0; right:0; bottom:0; margin:auto; width:100%;}
.goodsCont {-webkit-flex:1; -moz-flex:1; -ms-flex:1; -o-flex:1; flex:1; max-width:calc(100% - 82px); padding-left:10px;}
.goodsCont h3,.goodsCont p {font-size: 14px!important;}
.goodsCont h3,.goodsCont p,.goodsCont dt {overflow:hidden;max-width:100%;text-overflow:ellipsis;white-space:nowrap; } 

.goodsCont .priceFont {padding-right:10px;}
.goodsCont .textFl {width:auto;max-width: calc(100% - 92px);}
.pdr70 {padding-right:100px;}
/*盘点清单弹窗 end*/

</style>





// WEBPACK FOOTER //
// src/views/DeliveryFolder/ShippedOrderList_SellerMemo.vue